import { Component, OnInit, Input } from '@angular/core';
import { ConfigServiceService } from '../../config/shared/config-service.service';
import { TranslationService } from '../../shared';
import { FormElementEmailOptIn } from '../shared/model/email-optin/form-element-email-optin.model';
import { EmailNotificationSettingsDto } from '../../admin/global-settings/shared/dto/email-notification-settings.dto';

@Component({
  selector: 'wl-form-builder-email-optin-edit-element',
  providers: [ConfigServiceService, TranslationService],
  templateUrl: 'form-builder-email-optin-edit-element.component.html',
  styleUrls: ['form-builder-email-optin-edit-element.component.less'],
    standalone: false
})
export class FormBuilderEmailOptIntEditElementComponent {
  public optOutDefault: boolean;
  public emailOptInData: FormElementEmailOptIn;
  public constructor(
    private _configConfigService: ConfigServiceService,
    private _translationService: TranslationService,
  ) {}

  ngOnInit(): void {
    this.emailOptInData = new FormElementEmailOptIn();
    this._configConfigService.getEmailNotificationSettings().then((data: EmailNotificationSettingsDto) => {
      this.optOutDefault = data.OptOutByDefault;
    })
    if (!this.emailOptInData.Label) {
      this.emailOptInData.Label = this._translationService.getInstant('form-builder.legos.email-optin.label.default');
    }
    if (!this.emailOptInData.Message) {
      this.emailOptInData.Message = this._translationService.getInstant('form-builder.legos.email-optin.message.default');
    }
  }
}
